import mapboxgl from 'mapbox-gl';
const campCoordinates = [9.2963845, 48.8309386];
const markerEl = document.createElement('div');
markerEl.className = 'marker';
document.addEventListener('DOMContentLoaded', () => {
    const mapBlocks = document.querySelectorAll('section.map');
    Array.from(mapBlocks).forEach(mapBlock => {
        mapboxgl.accessToken = process.env.MAPBOX_TOKEN;
        const map = new mapboxgl.Map({
            container: mapBlock.querySelector('.map-container'),
            style: 'mapbox://styles/adrianfahrbach/cltq9inno00wj01pk8ukb3npn',
            center: campCoordinates,
            scrollZoom: false,
            zoom: 16,
        });
        new mapboxgl.Marker(markerEl).setLngLat(campCoordinates).addTo(map);
        const navigationControls = new mapboxgl.NavigationControl();
        map.addControl(navigationControls, 'bottom-right');
    });
});
